import React from 'react';
import ReactMarkdown from 'react-markdown';
import { toMarkdown } from '../../utils/terms';

// react-markdown does not render raw HTML, so stored terms can't inject markup.
const TermsContent = ({ text, className = '' }) => (
    <div className={`space-y-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 ${className}`}>
        <ReactMarkdown>{toMarkdown(text)}</ReactMarkdown>
    </div>
);

export default TermsContent;
